var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQ6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0952 11.2393C15.0952 13.3163 13.4275 15.0001 11.3703 15.0001C9.31306 15.0001 7.64534 13.3163 7.64534 11.2393C7.64534 9.16227 9.31306 7.47852 11.3703 7.47852C13.4275 7.47852 15.0952 9.16227 15.0952 11.2393ZM4.17584 19.8998C5.81481 17.5036 8.50742 16.0745 11.3703 16.0745C14.2332 16.0745 16.9258 17.5036 18.5541 19.8998C18.7351 20.1577 18.8202 20.4478 18.8202 20.7486V21.4471C18.8202 22.038 18.3413 22.5216 17.7559 22.5216H4.98468C4.39933 22.5216 3.92041 22.038 3.92041 21.4471V20.7486C3.92041 20.4478 4.00555 20.1577 4.17584 19.8998ZM19.8845 16.0745C21.6478 16.0745 23.0773 14.6313 23.0773 12.851C23.0773 11.0707 21.6478 9.6275 19.8845 9.6275C18.1211 9.6275 16.6917 11.0707 16.6917 12.851C16.6917 14.6313 18.1211 16.0745 19.8845 16.0745ZM19.8845 17.149C22.2791 17.149 24.5141 18.3417 25.8763 20.3403C26.0147 20.5445 26.0892 20.7916 26.0786 21.0387V21.447C26.0786 22.038 25.5996 22.5215 25.0143 22.5215H19.8739V20.7379C19.8739 20.2221 19.7249 19.7278 19.4375 19.298C18.9692 18.6103 18.4264 17.9979 17.8198 17.4606C18.4903 17.2672 19.1714 17.149 19.8845 17.149Z",
    fill: "#CDA876"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ6);
export default __webpack_public_path__ + "static/media/q6.bb1baf869b474acb1c425f853b6621f5.svg";
export { ForwardRef as ReactComponent };